import React from 'react';
import { snakeCaseToTitleCase } from '~/lib/cases';
import Clause from './clause';
import DecPageField from './decPageField';
const DataElement = ({ category, k, value }) => {
    k = k.replaceAll('100_pct_', '');
    return React.createElement("div", { className: 'data-element' },
        category && React.createElement("div", { className: 'category' }, snakeCaseToTitleCase(category)),
        category === 'dec_page_fields' && React.createElement(DecPageField, { v: value, k: k }),
        category === 'clauses' && React.createElement(Clause, { v: value, k: k }));
};
export default DataElement;
